import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#cash-out-refinance-app-v2', App);
